import { SET_LOGGED_IN_STATUS } from 'marketing-website/constants/actions';

export function setLoggedInStatus({
  isLoggedIn,
  isSubscribed,
  username,
  companyName,
  email,
  testGroupNumber,
}) {
  return {
    type: SET_LOGGED_IN_STATUS,
    isLoggedIn,
    isSubscribed,
    username,
    companyName,
    email,
    testGroupNumber,
  };
}



// WEBPACK FOOTER //
// ./src/actionCreators/user.js